module.exports = __webpack_public_path__ + "img/video-13.3ddca274.png";